<template>
  <section class="py-10">
    <h5 class="font-weight-bold text-h5 text-typo mb-0">Сургуулийн бүртгэл</h5>
    <v-row justify="end" class="mr-2">
      <v-toolbar flat color="transparent">
        <v-row justify="space-between">
          <v-row justify="end">
            <!-- <span @click="_xxx" style="cursor: pointer">kdfjsjdf</span> -->
            <v-btn
              small
              class="
                border-radius-sm
                text-xxs text-white
                me-1
                shadow-none
                font-weight-bold
                px-3
                py-1
                btn-success
                bg-gradient-success
              "
              elevation="0"
              :ripple="false"
              @click="_newDialog(null)"
              :title="$attrs.name + ' нэмэx'"
            >
              <v-icon class="darken-2" text>Сургууль+</v-icon>
            </v-btn>
          </v-row>
        </v-row>
      </v-toolbar>
    </v-row>
    <v-card class="border-radius-xl card-shadow">
      <h1 class="mx-4 my-4">
        {{ totalNumberOfStudents }}
        <span class="grey--text" style="font-size: 12pt">оюутан</span>
      </h1>
      <v-data-table
        :headers="headers"
        v-if="items && items.length > 0"
        :items="items"
        :items-per-page="500"
      >
        <template slot="item" slot-scope="props">
          <tr @click="_detail(item, props.item.index)">
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>
              {{ props.item.directorName }}
            </td>
            <td>{{ props.item.directorPhone }}</td>
            <td>
              {{ props.item.managerName }}
            </td>
            <td>{{ props.item.managerPhone }}</td>
            <td>{{ props.item.teachersNumber }}</td>
            <td>{{ props.item.studentsNumber12 }}</td>
            <td>{{ props.item.description }}</td>
            <td>
              <template>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                >
                  mdi-pencil
                </v-icon>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-card v-else class="text-center" height="300">
        <v-row justify="center">
          <v-img
            class="mx-auto mt-16"
            max-height="100"
            max-width="100"
            src="/assets/img/notfound.png"
          ></v-img>
        </v-row>
        <h5 class="py-10 text-danger">Мэдээлэл оруулаагүй байна</h5>
      </v-card>
    </v-card>

    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="800px">
      <v-card class="py-4">
        <v-card-title class="headline">
          Шинэ "{{ $attrs.name }}" нэмэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field autofocus
                  v-model.trim="editedItem.name"
                  label="Нэр"
                  :rules="[rules.required]"
                  :error="error"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.email"
                  label="Систем xариуцаx xүний Gmail имэйл"
                  :rules="[rules.emailRequired]"
                  :error="error"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.directorLastName"
                  label="Захирлын овог"
                  :rules="[rules.nameRequired]"
                  :error="error"
                />
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.directorFirstName"
                  label="Захирлын нэр"
                  :rules="[rules.nameRequired]"
                  :error="error"
                />
              </v-col>

              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.directorPhone"
                  label="Утас"
                  :rules="[rules.phoneRequired]"
                  :error="error"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.managerLastName"
                  label="Менежерийн овог"
                  :rules="[rules.nameRequired]"
                  :error="error"
                />
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.managerFirstName"
                  label="Менежерийн нэр"
                  :rules="[rules.nameRequired]"
                  :error="error"
                />
              </v-col>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                  v-model.trim="editedItem.managerPhone"
                  label="Утас"
                  :rules="[rules.phoneRequired]"
                  :error="error"
                />
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model="editedItem.code" label="Код" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <!-- <label class="text-xs text-typo font-weight-bolder ms-1"
                  >Тэмдэглэл</label
                > -->

                <v-textarea
                  v-model.trim="editedItem.description"
                  outlined
                  label="Сургуулийн танилцуулга бичиx"
                  color="rgba(0,0,0,.6)"
                  class="
                    font-size-input
                    border
                    text-light-input
                    border-radius-md
                    mt-2
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  v-model="editedItem.numberOfSekz"
                  label="Зааx арга зүйн тоо"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-0">
              <v-checkbox
                label="Бага сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="Дунд сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="Аxлаx сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            class="btn-primary bg-gradient-primary text-capitalize"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            dark
            color="red"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Устгаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

export default {
  name: "RegularTablesView",
  data: () => ({
    error: false,
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    items: [],
    messageNotification: null,
    bulkText: null,
    rules: {
      required: (value) => !!value || "Шаардлагатай.",
      emailRequired: (value) => !!value || "Gmail шаардлагатай.",
      phoneRequired: (value) => !!value || "Утас шаардлагатай.",
      nameRequired: (value) => !!value || "Нэр, овог шаардлагатай.",
    },
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    totalNumberOfStudents() {
      var sum = 0;
      if (this.items && this.items.length > 0) {
        for (var school of this.items) {
          sum = sum + school.studentsNumber12;
        }
      }
      return sum;
    },

    isEYESH_APP() {
      return fb.EYESH_APP;
    },
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },

        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "name",
          width: "20%",
        },
        {
          text: "Имэйл",
          align: "start",
          sortable: true,
          value: "email",
        },
        {
          text: "Захирал",
          align: "start",
          sortable: true,
          value: "directorName",
        },

        {
          text: "Заxирлын утас",
          align: "start",
          sortable: true,
          value: "directorPhone",
        },
        {
          text: "Менежер",
          align: "start",
          sortable: true,
          value: "managerName",
        },
        {
          text: "Менежер утас",
          align: "start",
          sortable: true,
          value: "managerPhone",
        },

        {
          text: "Багшийн тоо",
          align: "start",
          sortable: true,
          value: "teachersNumber",
        },
        {
          text: "Сурагчдын тоо",
          align: "start",
          sortable: true,
          value: "studentsNumber",
        },
      ];
    },
  },
  created() {
    this._read();
  },

  methods: {
    _getPath() {
      return "schools";
    },
    _xxx() {
      console.log("dfsdfsdf");

      // fb.db
      //   .collectionGroup("students")
      //   .get()
      //   .then((students) => {
      //     console.log(students.size)
      //     students.forEach((doc) => {
      //       doc.ref.update({ deleted: false }).then(()=>{
      //         console.log("done")
      //       })

      //     });
      //   });

      // var sum = 0
      // for(var school of this.items){
      //   sum = sum + school.studentsNumber12
      //   school.ref.update({studentsNumber12: school.studentsNumber12})
      // }
      // console.log(sum)
    },
    _add() {
      console.log();
    },
    _newDialog(item) {
      this.editedItem = {};
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      }
    },
    _newBulkDialog() {
      this.newBulkDialog = true;
    },
    _detail(item) {
      this.editedItem = item;
      this.detailDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.update({ deleted: true }).then(() => {
          this.editedItem = this.defaultItem;
          this.deleteDialog = false;
        });
      }
    },
    cancel() {
      this._closeEdit();
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // });
    },
    async saveItem() {
      //var tmp = Object.assign({}, this.editedItem);
      if (
        this.editedItem.name &&
        this.editedItem.name.trim() !== ""  
      ) {
        this.editedItem.createdAt = new Date();
        if (!this.editedItem.directorName) this.editedItem.directorName = null;
        if (!this.editedItem.managerName) this.editedItem.managerName = null;

        if (this.editedIndex === -1) {
          this.editedItem.realschool = true;
          this.editedItem.deleted = false;
          this.editedItem.email =  this.editedItem.email?this.editedItem.email.toLowerCase():null

          if (new Date().getMonth() + 1 < 7) {
            this.editedItem.currentYear = new Date().getFullYear() - 1;
          } else {
            this.editedItem.currentYear = new Date().getFullYear();
          }

          this.editedItem.currentYearIndex = 0;

          await fb.db.collection(this._getPath()).doc().set(this.editedItem).then(()=>{
            this._closeEdit();
          })

          // if (ss.path) {
          //   var newAdmin = await ss.collection("teachers").add({
          //     firstName: "Admin - " + this.editedItem.name,
          //     email: tmp.email.toLowerCase(),
          //     role: this.isEYESH_APP ? "eyeshadmin" : "admin",
          //     roleName: this.isEYESH_APP ? "EyeshAdmin" : "Admin",
          //   });
          //   ss.update({ adminRef: newAdmin }).then(() => {
          //     this._closeEdit();
          //   });
          // }
        } else {
          this.editedItem.email = this.editedItem.email?this.editedItem.email.trim().toLowerCase():null
          this.editedItem.ref
            .update(this.editedItem)
            .then(() => {
              // tmp.adminRef.update({
              //   email: tmp.email.toLowerCase(),
              //   role: this.isEYESH_APP ? "eyeshadmin" : "admin",
              //   roleName: this.isEYESH_APP ? "EyeshAdmin" : "Admin",
              // });
            })
            .then(() => {
              this._closeEdit();
            });
        }
      } else {
        this.error = true;
        this.messageNotification =
          "Доод тал нь <<нэр, email>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },

    _read() {
      fb.db
        .collection("schools")
        .where("deleted", "==", false)
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.items = [];
          var index = 0;
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            //item.studentsNumber12 = null;
            item.teachersNumber2 = null;
            item.directorName = "";
            item.directorName = item.directorLastName
              ? item.directorLastName + ", " + item.directorFirstName
              : item.directorFirstName;
            item.managerName = item.managerLastName
              ? item.managerLastName + ", " + item.managerFirstName
              : item.managerFirstName;

            item.index = ++index;
            this.items.push(item);
            //item.ref.collection("students").where("departmentName-2022","==",12).get().then((students) => {
            // students.forEach((doc)=>{
            //   let dd = doc.data()
            //   console.log(dd["departmentName-2023"],dd["classGroupName-2023"])
            //   doc.ref.update({"departmentName-2022": dd["departmentName-2023"],"classGroupName-2023": dd["classGroupName-2023"]})
            // })
            //item.studentsNumber12 = students.size;
            //this.items.push(item);
            // if (
            //   item.studentsNumber &&
            //   item.studentsNumber < item.studentsNumber12
            // ) {
            //   item.ref.update({ studentsNumber: item.studentsNumber12 });
            // } else if (
            //   item.studentsNumber == undefined ||
            //   item.studentsNumber == null
            // ) {
            //   item.ref.update({ studentsNumber: item.studentsNumber12 });
            // }
            //item.ref.update({ studentsNumber: item.studentsNumber12 });
            //});
            item.ref.collection("teachers").onSnapshot((teachers) => {
              item.teachersNumber2 = teachers.size;
              // if (
              //   item.teachersNumber &&
              //   item.teachersNumber < item.teachersNumber2
              // ) {
              //   item.ref.update({ teachersNumber: item.teachersNumber2 });
              // } else if (
              //   item.teachersNumber == undefined ||
              //   item.teachersNumber == null
              // ) {
              //   item.ref.update({ teachersNumber: item.teachersNumber2 });
              // }
            });
            // if (item.email) {
            //   item.ref.collection("teachers").where("email", "==", item.email).limit(1).get().then((docs)=>{
            //     docs.forEach((doc)=>{
            //       if(doc.exists){
            //         item.admin = doc.data()
            //         item.admin.ref = doc.ref
            //         item.admin.ref.update({role: "eyeshadmin", roleName:"EyeshAdmin"}).then(()=>{
            //           console.log(item.admin.ref.path)
            //         })
            //       }
            //     })
            //   })
            // }
            // this.items.push(item);
          });
        });
    },
  },
};
</script>
